import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'plural',
    standalone: true,
})
export class PluralPipe implements PipeTransform {
  transform(value: number, cases: [string, string, string], withoutValue?: boolean): string {
    const currentCase = this.getCurrentPluralCase(value, cases);

    return !!withoutValue ? currentCase : `${value} ${currentCase}`;
  }

  private getCurrentPluralCase(value: number, cases: [string, string, string]): string {
    const [ one, few, more ] = cases;

    if (value % 10 === 1 && value % 100 !== 11) {
      return one;
    }

    return value % 10 >= 2 && value % 10 <= 4 && (value % 100 < 10 || value % 100 >= 20) ? few : more;

  }
}
